export default function CaseStudiesSection() {
  const caseStudies = [
    {
      title: 'The 40-Year Accumulation',
      situation: 'Inherited home with 40+ years of newspapers, magazines, and personal items filling every room',
      challenge: 'Family overwhelmed by the volume of items and emotional attachment to deceased parent\'s belongings',
      solution: 'Purchased property as-is, carefully sorted through items to identify valuables and family heirlooms, donated usable items to charity, and completed full cleanup in 3 weeks',
      outcome: 'Family received fair cash payment and recovered several valuable items they didn\'t know existed, including rare coins and family photos',
      image: 'https://public.readdy.ai/ai/img_res/1e6ab7600a7be8a2165ff379404f7e1f.jpg'
    },
    {
      title: 'The Non-Livable Property',
      situation: 'Property condemned by city due to unsafe living conditions, blocked exits, and structural concerns',
      challenge: 'Owner facing daily fines from the city and unable to afford cleanup or repairs',
      solution: 'Worked with city officials to halt fines during purchase process, bought property immediately, and completed comprehensive cleanup and structural repairs',
      outcome: 'Owner avoided bankruptcy and additional fines, property restored to safe condition and returned to productive use',
      image: 'https://readdy.ai/api/search-image?query=severely%20cluttered%20house%20interior%20with%20blocked%20doorways%20and%20exits%20unsafe%20living%20conditions%20items%20piled%20high%20creating%20hazardous%20environment%20condemned%20property%20situation&width=700&height=500&seq=hoarder-case2-012&orientation=landscape'
    },
    {
      title: 'The Assisted Living Transition',
      situation: 'Elderly homeowner moving to assisted living facility, house filled with lifetime of possessions',
      challenge: 'Family living out of state, limited time to handle cleanup, emotional difficulty for homeowner',
      solution: 'Allowed homeowner to take time selecting items to keep, purchased property with all remaining contents, handled entire cleanup process with sensitivity',
      outcome: 'Homeowner transitioned peacefully to assisted living with cherished items, family avoided stress of long-distance cleanup coordination',
      image: 'https://readdy.ai/api/search-image?query=elderly%20person%20carefully%20selecting%20precious%20belongings%20and%20memories%20from%20lifetime%20of%20possessions%20in%20home%20sentimental%20items%20family%20photos%20emotional%20transition%20moment%20warm%20lighting&width=700&height=500&seq=hoarder-case3-013&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Real <span className="text-teal-600">Success Stories</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Every hoarder house situation is unique. Here are a few examples of how we've helped property owners find solutions.
          </p>
        </div>

        <div className="space-y-16">
          {caseStudies.map((study, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg">
              <div className={`grid md:grid-cols-2 gap-8 ${index % 2 === 1 ? 'md:grid-flow-dense' : ''}`}>
                <div className={`${index % 2 === 1 ? 'md:col-start-2' : ''}`}>
                  <img 
                    src={study.image}
                    alt={study.title}
                    className="w-full h-full object-cover min-h-[400px]"
                  />
                </div>
                <div className="p-10">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">{study.title}</h3>
                  
                  <div className="space-y-4">
                    <div>
                      <h4 className="font-bold text-teal-600 mb-2 flex items-center">
                        <i className="ri-file-list-line mr-2"></i>
                        The Situation
                      </h4>
                      <p className="text-gray-700 leading-relaxed">{study.situation}</p>
                    </div>

                    <div>
                      <h4 className="font-bold text-orange-600 mb-2 flex items-center">
                        <i className="ri-alert-line mr-2"></i>
                        The Challenge
                      </h4>
                      <p className="text-gray-700 leading-relaxed">{study.challenge}</p>
                    </div>

                    <div>
                      <h4 className="font-bold text-blue-600 mb-2 flex items-center">
                        <i className="ri-lightbulb-line mr-2"></i>
                        Our Solution
                      </h4>
                      <p className="text-gray-700 leading-relaxed">{study.solution}</p>
                    </div>

                    <div>
                      <h4 className="font-bold text-green-600 mb-2 flex items-center">
                        <i className="ri-checkbox-circle-line mr-2"></i>
                        The Outcome
                      </h4>
                      <p className="text-gray-700 leading-relaxed">{study.outcome}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            These are just a few examples of the hundreds of hoarder houses we've successfully purchased and restored. Your situation is unique, and we'll work with you to find the best solution for your specific needs.
          </p>
          <button 
            onClick={() => {
              const form = document.getElementById('contact-form');
              if (form) form.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-teal-600 text-white text-lg font-semibold rounded-lg hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Share Your Situation With Us
          </button>
        </div>
      </div>
    </section>
  );
}
